import axios from 'axios';
import { createV4API } from './v4';

const API_URL = process.env.REACT_APP_API_URL;
// Создаем инстанс axios с базовым URL
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});
// Добавляем интерцептор для добавления токена к запросам
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// API для аутентификации
export const tgUserAPI = {
    getTgUsers: (page, limit, search) => api.get('/tguser/list?page='+page+'&limit='+limit+'&search='+search),
    getInactiveUsers: (page, limit) => api.get('/tguser/inactive?page='+page+'&limit='+limit),
    editUserBalance: (id, balance) => api.post('/tguser/editbalance', {userId: id, balance: balance}),
    banUser: (userId) => api.post(`/tguser/ban/${userId}`),
    unbanUser: (userId) => api.post(`/tguser/unban/${userId}`),
    editUserMeta: (id, orders, comment) => api.post('/tguser/editmeta', { userId: id, orders, comment })
}

export const giftCardAPI = {
    getGiftCards: (page = 1, limit = 10, search = '') => api.get(`/giftcards?page=${page}&limit=${limit}&search=${search}`),
    getGiftCardById: (id) => api.get(`/giftcards/${id}`),
    createGiftCard: (data) => api.post('/giftcards', data),
    updateGiftCard: (id, data) => api.put(`/giftcards/${id}`, data),
    deleteGiftCard: (id) => api.delete(`/giftcards/${id}`),
    getGiftCardStats: () => api.get('/giftcards/stats'),
    getGiftCardPriceList: () => api.get('/giftcards/pricelist')
}
export const authAPI = {
    login: (data) => api.post('/auth', data),
    checkToken: () => api.post('/auth/check'),
    logout: () => api.post('/auth/logout'),
};
export const userAPI = {
    createUser: (data) => api.post('/users/create', data),
    getUsers: () => api.get('/users'),
    deleteUser: (id) => api.delete(`/users/${id}`),
    updateUser: (id, data) => api.put(`/users/${id}`, data),
}

export const goodsAPI = {
    createGoods: (data) => {
        return api.post('/goods/create', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    updateGoods: (id, data) => {
        return api.put(`/goods/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    addMarket: (id) => api.post(`/goods/${id}/add-market`),
    getGoods: (page, limit, query, filtre, partner_id) => api.get(`/goods?page=${page}&limit=${limit}`+ (query ? `&search=${query}` : '') + (filtre ? `&filtre=${filtre}` : '') + (partner_id ? `&partner_id=${partner_id}` : '')),
    getGoodsById: (id) => api.get(`/goods/${id}`),
    deleteGoods: (id) => api.delete(`/goods/${id}`),
    uploadExcel: (data) => api.post('/goods/upload', data),
}

export const imgAPI = {
    getImg: (name, width, height) => process.env.REACT_APP_API_URL + `/image?filename=${name}&width=${width}&height=${height}`,
}
export const partnersAPI = {
    createPartner: (data) => api.post('/partners/create', data),
    updatePartner: (id, data) => api.put(`/partners/${id}`, data),
    getPartners: () => api.get(`/partners`),
    getPartnersById: (id) => api.get(`/partners/${id}`),
    deletePartner: (id) => api.delete(`/partners/${id}`),
}
export const processingAPI = {
    emiratesMethods: (id) => api.get(`/processing/${id}/emirates-methods`),
    create: (data) => api.post('/processing/create', data),
    getList: () => api.get('/processing'),
    reorder: (order) => api.post('/processing/reorder', { order }),
    update: (id, data) => api.put(`/processing/${id}`, data),
    getMerchants: (id) => api.get(`/processing/${id}/merchants`),
    setMerchants: (id, merchantIds) => api.post(`/processing/${id}/merchants`, { merchantIds }),
    getGroups: () => api.get('/processing/groups/list'),
    getByGroup: (group) => api.get(`/processing/groups/${group}`),
    reorderInGroup: (group, order) => api.post(`/processing/groups/${group}/reorder`, { order }),
    moveToGroup: (id, group) => api.post(`/processing/${id}/move-to-group`, { group }),
    getProcGroups: () => api.get('/procgroups'),
    updateProcGroup: (id, data) => api.put(`/procgroups/${id}`, data),
}

export const runtimeProvidersAPI = {
    list: () => api.get('/runtime-providers'),
    getById: (id) => api.get(`/runtime-providers/${id}`),
    create: (data) => api.post('/runtime-providers', data),
    update: (id, data) => api.put(`/runtime-providers/${id}`, data),
    remove: (id) => api.delete(`/runtime-providers/${id}`),
    activate: (id) => api.post(`/runtime-providers/${id}/activate`),
    test: (id, payload) => api.post(`/runtime-providers/${id}/test`, payload),
}

export const cryptoAPI = {
    createWallet: (data) => api.post('/crypto/wallets', data),
    deleteWallet: (id) => api.delete(`/crypto/wallets/${id}`),
    getWallets: (page,limit,search) => api.get(`/crypto/wallets`, {params:{search, page, limit}}),

}
export const ordersAPI = {
    getFunPayOrders: () => api.get(`/orders/funpay`),
    getOrders: (filters, page, limit) => api.post(`/orders/list`, {params:{filters, page:page, limit:limit}}),
    lookupExportOrders: (query, options = {}) => api.post('/orders/export/lookup', { query }, options),
    previewExport: (range, options = {}) => api.post('/orders/export/preview', range, options),
    exportPage: (range, options = {}) => api.post('/orders/export/page', range, options),
    getOrdersPackages: (data) => api.post(`/orders/packages`, data),
    getFunPayChat: (id) => api.get(`/orders/funpay-chat/${id}`),
    getFunPayChatSendClient: (id, message) => api.post(`/orders/funpay-chat-send-client/${id}`, { message }),
    getFunPayChatSendSeller: (id, message) => api.post(`/orders/funpay-chat-send-seller/${id}`, { message }),
    getFunPayChatClose: (id) => api.post(`/orders/funpay-chat-close/${id}`),
    setPaid: (id) => api.post(`/orders/set-paid/${id}`),
    orderPaidAmount: (id, paid) => api.post(`/order-paid-amount`, {order_id: id, paid: paid}),
    cancelFromPanel: (id, reason) => api.post(`/orders/cancel-from-panel/${id}`, { reason }),
    sendCallbackFromPanel: (id) => api.post(`/orders/send-callback/${id}`),
    updateStatusFromPanel: (id, status, message) => api.post(`/orders/update-status/${id}`, { status, message }),
    checkDucaStatusFromPanel: (id) => api.post(`/orders/duca/check-status/${id}`),
    checkPlatformApiStatusFromPanel: (id, config) => api.post(`/orders/platformapi/check-status/${id}`, {}, config),
}

export const clientsAPI = {
    createClient: (data) => api.post('/clients/create', data),
    getClients: (page = 1, limit = 10, filters = {}) => {
        let url = `/clients?page=${page}&limit=${limit}`;
        
        console.log('Полученные фильтры в API:', JSON.stringify(filters));
        
        // Добавляем параметры фильтрации в URL, если они указаны
        if (filters.market) {
            url += `&market=${filters.market}`;
            console.log('Добавлен фильтр по маркету:', filters.market);
        }
        if (filters.status) {
            url += `&status=${filters.status}`;
            console.log('Добавлен фильтр по статусу:', filters.status);
        }
        if (filters.search) {
            url += `&search=${filters.search}`;
            console.log('Добавлен поисковый запрос:', filters.search);
        }
        
        console.log('Итоговый URL запроса:', url);
        return api.get(url);
    },
    getClientsById: (id) => api.get(`/clients/${id}`),
    updateClient: (id, data) => api.put(`/clients/${id}`, data),
    getScreen: (id) => api.get(`/screanclient/${id}`),
    deleteClient: (id) => api.delete(`/clients/${id}`),
}
export const merchantAPI = {
    createMerchant: (data) => api.post('/merchants/create', data),
    getMerchant: () => api.get('/merchants'),
    getMerchantById: (id) => api.get(`/merchants/${id}`),
    updateMerchant: (id, data) => api.put(`/merchants/${id}`, data),
    deleteMerchant: (id) => api.delete(`/merchants/${id}`),
    reorderMerchants: (merchantIds) => api.post('/merchants/reorder', { merchantIds }),
}
// Dashboard / Me endpoints
export const meAPI = {
    getMyMerchants: () => api.get('/me/merchants'),
}
export const dashboardAPI = {
    getCourierStats: (params) => api.get('/dashboard/courier-stats', { params }),
    getCourierSalaries: (params) => api.get('/dashboard/courier-stats/salaries', { params }),
    getCourierById: (courierId, params) => api.get(`/dashboard/courier-stats/${courierId}`, { params }),
    getCourierPenalties: (courierId, params) => api.get(`/dashboard/courier-stats/${courierId}/penalties`, { params }),
    createPenalty: (payload, params) => api.post('/dashboard/courier-stats/penalty', payload, { params }),
    cancelPenalty: (penaltyId, payload, params) => api.put(`/dashboard/courier-stats/penalty/${penaltyId}/cancel`, payload, { params }),
}
// Stats endpoints (for Home top blocks)
export const statsAPI = {
    getTotals: (params) => api.get('/dashboard/stats', { params }),
    getCrypto: (params) => api.get('/dashboard/stats/crypto', { params }),
    getProducts: (params) => api.get('/dashboard/stats/products-stats', { params }),
}
export const bugTrAPI = {
    // Public for merchants (apikey in body)
    createPublic: (payload) => api.post('/bugtr', payload),
    // Admin panel
    list: (params = {}) => api.get('/bugtr', { params }),
    getOne: (id) => api.get(`/bugtr/${id}`),
    update: (id, data) => api.put(`/bugtr/${id}`, data),
}
// TG Accounts endpoints
export const tgAccountsAPI = {
    createAccount: (payload) => api.post('/tg-accounts/create', payload),
    getAccounts: (params = {}) => api.get('/tg-accounts', { params }),
    getAccountById: (id) => api.get(`/tg-accounts/${id}`),
    updateAccount: (id, payload) => api.put(`/tg-accounts/${id}`, payload),
    startAuth: (id) => api.post(`/tg-accounts/${id}/start-auth`),
    submitCode: (id, code) => api.post(`/tg-accounts/${id}/submit-code`, { code }),
    resendCode: (id) => api.post(`/tg-accounts/${id}/resend-code`),
    submitPassword: (id, password) => api.post(`/tg-accounts/${id}/submit-password`, { password }),
    getStatus: (id) => api.get(`/tg-accounts/${id}/status`),
    resume: (id) => api.post(`/tg-accounts/${id}/resume`),
    relogin: (id) => api.post(`/tg-accounts/${id}/relogin`),
    testMessage: (id, message) => api.post(`/tg-accounts/${id}/test-message`, { message }),
    getChats: (id, limit = 20) => api.get(`/tg-accounts/${id}/chats?limit=${limit}`),
    sendMessage: (id, chatId, message) => api.post(`/tg-accounts/${id}/send-message`, { chatId, message }),
    searchUsers: (id, query, limit = 10) => api.get(`/tg-accounts/${id}/search-users?query=${encodeURIComponent(query)}&limit=${limit}`),
    getChatHistory: (id, chatId, limit = 50, fromMessageId = 0) => api.get(`/tg-accounts/${id}/chats/${chatId}/history?limit=${limit}&fromMessageId=${fromMessageId}`),
    deleteAccount: (id) => api.delete(`/tg-accounts/${id}`),
    syncOrders: () => api.post('/tg-accounts/sync-orders'),
    syncAccountOrders: (id) => api.post(`/tg-accounts/${id}/sync-orders`),
}
// Broadcasts (TDLib mass messaging)
export const broadcastAPI = {
    create: ({ apikey, title = '', message = '', targets = [], rate_limit_ms = 1500 }) =>
        api.post('/broadcast/create', { apikey, title, message, targets, rate_limit_ms }),
    progress: (apikey) => api.get('/broadcast/progress', { params: { apikey } }),
    all: (admin_key) => api.get('/broadcast/all', { params: { admin_key } }),
}

// Tickets API
export const ticketsAPI = {
    getTickets: (params = {}) => api.get('/tickets', { params }),
    getTicketById: (id) => api.get(`/tickets/${id}`),
    assignTicket: (id) => api.post(`/tickets/${id}/assign`),
    replyToTicket: (id, message, attachments = []) => api.post(`/tickets/${id}/reply`, { message, attachments }),
    approveTicket: (id, newLimit) => api.post(`/tickets/${id}/approve`, { newLimit }),
    rejectTicket: (id, reason) => api.post(`/tickets/${id}/reject`, { reason }),
    closeTicket: (id) => api.post(`/tickets/${id}/close`),
    markOrderAsPaid: (id, addBalance = false) => api.post(`/tickets/${id}/mark-paid`, { addBalance }),
    getNewTicketsCount: (since) => api.get('/tickets/stats/new-count', { params: { since } }),
}

// Blacklist API
export const blacklistAPI = {
    getAll: (params) => api.post('/blacklist/all', { params }),
}

// Profit Report API
export const profitAPI = {
    getReport: (params) => api.post('/profit/report', { params }),
}

// Games API
export const gamesAPI = {
    create: (payload) => api.post('/games/create', payload),
    list: () => api.get('/games'),
    history: (params = {}) => api.get('/games/history', { params }),
    earnings: (params = {}) => api.get('/games/earnings', { params }),
    roll: (payload) => api.post('/games/roll', payload),
}

export const v4API = createV4API(api);

export default api;
